// src/services/companyDataService.js

// CSV Company Data - All 163 entries from your provided data
const companyData = [
  {companyName: "LTF Life Changer Test User", mobileNo: "8698200444"},
  {companyName: "L&T Finance Ltd.", mobileNo: "9920932730"},
  {companyName: "URBAN MONEY PVT LTD", mobileNo: "8928794628"},
  {companyName: "AADIFIDELIS SOLUTIONS PRIVATE LIMITED", mobileNo: "8238996055"},
  {companyName: "SIIA Advisory Consultancy LLP", mobileNo: "9820125829"},
  {companyName: "FIN SOLUTION", mobileNo: "9920057082"},
  {companyName: "FINEOTERIC CONSULTING PRIVATE LIMITED", mobileNo: "9892033276"},
  {companyName: "ARK SOLUTIONS", mobileNo: "9673542107"},
  {companyName: "VERTEX SERVICES", mobileNo: "9879529435"},
  {companyName: "MONEYMINE PROFESSIONAL SERVICES PVT LTD", mobileNo: "9898704606"},
  {companyName: "MHP Services", mobileNo: "9892517650"},
  {companyName: "OSM Capital Advisors Private Limited", mobileNo: "9892822717"},
  {companyName: "Finwizz Financial services pvt Ltd", mobileNo: "9833562524"},
  {companyName: "Nafisa ansari and co", mobileNo: "9819532607"},
  {companyName: "Rupeeboss", mobileNo: "9820455298"},
  {companyName: "MONEYBAZAAR DIGITAL MARKETING PVT LTD", mobileNo: "9820989597"},
  {companyName: "CATEYE CONSULTANCY SERVICES PVT LTD", mobileNo: "9049002468"},
  {companyName: "MY MUDRA FINCORP PVT LTD", mobileNo: "9819828320"},
  {companyName: "Andromeda sales and distribution private limited", mobileNo: "9167112222"},
  {companyName: "RULOANS DISTRIBUTION SERVICES PRIVATE LIMITED", mobileNo: "9987884000"},
  {companyName: "FINDESTINATION", mobileNo: "9765407091"},
  {companyName: "HEXAFIN CONSULTANCY PVT LTD", mobileNo: "9871919565"},
  {companyName: "SERVQUAL ASSOCIIATES LLP", mobileNo: "9923009653"},
  {companyName: "SIMRAN MARKETING", mobileNo: "9830304584"},
  {companyName: "RIGHT CLICK SOLUTIONS", mobileNo: "9143400166"},
  {companyName: "SAJH CONSULTANCY SERVICES", mobileNo: "7003458141"},
  {companyName: "UNIQ SALES CORPORATION", mobileNo: "9836762136"},
  {companyName: "RAAHAT SERVICES", mobileNo: "9830045663"},
  {companyName: "FINBUD FINANCIAL SERVICES PRIVATE LIMITED", mobileNo: "9886014880"},
  {companyName: "MAHIR FINANCIAL SERVICES", mobileNo: "9375623124"},
  {companyName: "TRUEWIN FINTECH PVT LTD", mobileNo: "9825852600"},
  {companyName: "BALAJI FINCORP", mobileNo: "9831408603"},
  {companyName: "R R ASSOCIATES", mobileNo: "9836877799"},
  {companyName: "AADITRADEMART PVT LTD", mobileNo: "9004689658"},
  {companyName: "IMPETUS ADCON PRIVATE LIMITED", mobileNo: "9824000387"},
  {companyName: "PARKERS CONSULTING AND VENTURES PRIVATE LIMITED", mobileNo: "9893055575"},
  {companyName: "SDV FINCONSULTANT LLP", mobileNo: "9828020529"},
  {companyName: "MVN FINANCIAL ADVISORS PRIVATE LIMITED", mobileNo: "9953006518"},
  {companyName: "JBJ ASSOCIATES", mobileNo: "9891940007"},
  {companyName: "FUNDING MILLIONS", mobileNo: "9879000470"},
  {companyName: "STAR POWERZ DIGITAL TECHNOLOGIES PRIVATE LIMITED", mobileNo: "9910530280"},
  {companyName: "FUNDTRENDZ INDIA PRIVATE LIMITED", mobileNo: "9620999098"},
  {companyName: "FINDESK ASSOCIATES", mobileNo: "9825580650"},
  {companyName: "GENERATION NEXT BPO SERVICES", mobileNo: "9999612300"},
  {companyName: "S P FINANCE SOLUTION", mobileNo: "9804029250"},
  {companyName: "SBJ FINTECH SERVICES PRIVATE LIMITED", mobileNo: "9810479434"},
  {companyName: "APEX FINANCIAL SERVICES", mobileNo: "9699080888"},
  {companyName: "CHASE FLY FINCOM PRIVATE LIMITED", mobileNo: "9818591847"},
  {companyName: "GRV SOLUTIONS", mobileNo: "9841013236"},
  {companyName: "SPASH ADVISORS PRIVATE LIMITED", mobileNo: "9830853547"},
  {companyName: "SAPAN VIBHAKARBHAI SHAH", mobileNo: "9825433077"},
  {companyName: "FINDESK FISCAL SERVICES PRIVATE LIMITED", mobileNo: "9909006546"},
  {companyName: "DREAM INC", mobileNo: "9899771339"},
  {companyName: "AMPRI CONSULTANTS PRIVATE LIMITED", mobileNo: "9830320668"},
  {companyName: "LOAN NEEDZ", mobileNo: "9710444688"},
  {companyName: "R R FINMART PRIVATE LIMITED", mobileNo: "9326521524"},
  {companyName: "RAPTAS FINANCIAL SOLUTIONS PRIVATE LIMITED", mobileNo: "9527299997"},
  {companyName: "DENGI FINSERV PRIVATE LIMITED", mobileNo: "9999140643"},
  {companyName: "RAAJ KHOSLA AND CO PVT LTD", mobileNo: "9810081835"},
  {companyName: "ORENDA FINSERV LLP", mobileNo: "9537744669"},
  {companyName: "FINBORROW FINANCIAL SERVICES", mobileNo: "9879523839"},
  {companyName: "SRS CAPITAL PRIVATE LIMITED", mobileNo: "9052500789"},
  {companyName: "PROFINSERVE", mobileNo: "9840035059"},
  {companyName: "FINEXPERTS ADVISORY SERVICES PRIVATE LIMITED", mobileNo: "9000161162"},
  {companyName: "SMS LINKS", mobileNo: "8807755600"},
  {companyName: "FINKRISH SOLUTIONS PRIVATE LIMITED", mobileNo: "9818306353"},
  {companyName: "SIDDHI FIN SOLUTIONS", mobileNo: "9911836777"},
  {companyName: "ANJALEE FINANCIAL SERVICES", mobileNo: "9898146682"},
  {companyName: "ASQUARIAN CONSULTANTS PRIVATE LIMITED", mobileNo: "9811231722"},
  {companyName: "FALCON SOLUTIONS", mobileNo: "9901028295"},
  {companyName: "FINNEST TAHERA FINANCIAL SERVICES PVT LTD", mobileNo: "9008506009"},
  {companyName: "SANSOW INC", mobileNo: "9739500149"},
  {companyName: "MUKESH T SONAWANE", mobileNo: "8888059888"},
  {companyName: "V M FINEMARK LIMITED", mobileNo: "9825234576"},
  {companyName: "TRIDENT ASSOCIATES", mobileNo: "9825315128"},
  {companyName: "MONEYMAX FINGROW PVT LTD", mobileNo: "9841090817"},
  {companyName: "RUPIYAMART FIN LOCKERS PVT LTD", mobileNo: "8448660475"},
  {companyName: "T S MAHALINGAM SERVICES PVT LTD", mobileNo: "9841003444"},
  {companyName: "VELOCITY", mobileNo: "9818112943"},
  {companyName: "NEW HEIGHTS FINANCIAL PLANNERS PVT LTD", mobileNo: "8130644440"},
  {companyName: "MINDFIN SER PRIVATE LIMITED", mobileNo: "9916917983"},
  {companyName: "LMV FINANCIAL SERVICES PRIVATE LIMITED", mobileNo: "9959874455"},
  {companyName: "TIWARI FINANCIAL SERVICES", mobileNo: "9900175696"},
  {companyName: "SIDDHI IMAGINE FINTECH CONSULTANCY PVT LTD", mobileNo: "9811422207"},
  {companyName: "SKY HIGH FINANCE SOLUTIONS", mobileNo: "9870727170"},
  {companyName: "EKAGRA FINSERV PRIVATE LIMITED", mobileNo: "8109050888"},
  {companyName: "MAXMARK BUSINESS SOLUTION PVT LTD", mobileNo: "9924579249"},
  {companyName: "JP MANI INDIA", mobileNo: "9811132851"},
  {companyName: "SAMRIDHI ASSOCIATES PVT LTD", mobileNo: "9873927810"},
  {companyName: "M2M FINANCE", mobileNo: "9820358271"},
  {companyName: "ARUSH FINSERV", mobileNo: "9810381888"},
  {companyName: "INDCAP SERVICES", mobileNo: "9958072555"},
  {companyName: "JAI ENTERPRISES", mobileNo: "9811654442"},
  {companyName: "PERFECT MONEY", mobileNo: "9811997530"},
  {companyName: "FINNUP SOLUTIONS PRIVATE LIMITED", mobileNo: "8890864267"},
  {companyName: "S V ENTERPRISES FINANCIAL SERVICES", mobileNo: "9885442111"},
  {companyName: "AJ FINANCIAL SOLUTIONS", mobileNo: "9985920202"},
  {companyName: "ATHARVA CAPITAL", mobileNo: "9619450452"},
  {companyName: "NIYOGIN FINTECH LIMITED", mobileNo: "9324494385"},
  {companyName: "GO LENDIGO FINANCIAL SERVICES LLP", mobileNo: "9618969777"},
  {companyName: "CREDITOR INVERSIONS", mobileNo: "9811356905"},
  {companyName: "ROSIM CONSULTANTZ PRIVATE LIMITED", mobileNo: "9890090003"},
  {companyName: "ASCENT FINCON", mobileNo: "9810504880"},
  {companyName: "LEONARD FINANCE PVT LTD", mobileNo: "9699311945"},
  {companyName: "SAARATHI FINBIZ PRIVATE LIMITED", mobileNo: "7860757696"},
  {companyName: "ROYAL FINSERV CONSULTANTS PRIVATE LIMITED", mobileNo: "8819022007"},
  {companyName: "SAMARTH ASSOCIATES", mobileNo: "9246598459"},
  {companyName: "AIZEL FIN CORP", mobileNo: "9655610004"},
  {companyName: "P S Y S SERVICES PRIVATE LIMITED", mobileNo: "9701908044"},
  {companyName: "SIRI HARSHA SOLUTIONS", mobileNo: "9346630302"},
  {companyName: "CORPORATE I", mobileNo: "9842266154"},
  {companyName: "APEX FINMART SERVICES", mobileNo: "9815001355"},
  {companyName: "XTREME INDIA FINSERV PVT LTD", mobileNo: "9303760515"},
  {companyName: "BANK HOUSE", mobileNo: "9100910045"},
  {companyName: "SPARK ASSOCIATES", mobileNo: "7299961193"},
  {companyName: "ELITE ASSOCIATES", mobileNo: "9842236932"},
  {companyName: "ANNAI ASSOCIATES", mobileNo: "9894620198"},
  {companyName: "VALUED CONSULTING", mobileNo: "9886528016"},
  {companyName: "CREDITLINE FINANCE", mobileNo: "9920107670"},
  {companyName: "FINCON FINSERV", mobileNo: "9326000731"},
  {companyName: "CAPITALNINE SERVICES PRIVATE LIMITED", mobileNo: "9581789789"},
  {companyName: "FA WIZARD PRIVATE LIMITED", mobileNo: "9313321335"},
  {companyName: "PROSTAR FINSERVE PVT LTD", mobileNo: "8059797973"},
  {companyName: "J.M ENTERPRISE", mobileNo: "9737628761"},
  {companyName: "FINBRIDGE CONSULTING GROUP", mobileNo: "8904126053"},
  {companyName: "CAPITAL INSTA FINANCE", mobileNo: "9414066250"},
  {companyName: "OKTOBER6 INSIGHT PRIVATE LIMITED", mobileNo: "8097743143"},
  {companyName: "V V ASSOCIATES", mobileNo: "9884256559"},
  {companyName: "ROYALE CREDIT AND INVESTMENT", mobileNo: "9915911166"},
  {companyName: "REAL ASSOCIATES", mobileNo: "9600655786"},
  {companyName: "ALPHA ASSOCIATES", mobileNo: "9842165456"},
  {companyName: "M M LOANS", mobileNo: "8530121590"},
  {companyName: "SHRI SENTHUR VELAN ENTERPRISES", mobileNo: "9095078290"},
  {companyName: "SAI CREDITS", mobileNo: "9894700358"},
  {companyName: "LENDINGKART TECHNOLOGIES PVT LTD", mobileNo: "7968144500"},
  {companyName: "REALTURITY BUSINESS ADVISORY PRIVATE LIMITED", mobileNo: "9728765494"},
  {companyName: "TEZZRACT FINTECH PRIVATE LIMITED", mobileNo: "9819447944"},
  {companyName: "CONNECT FIN LIFE FINANCIAL SERVICES PVT LTD", mobileNo: "9688840004"},
  {companyName: "SKY ASSOCIATES", mobileNo: "9367699996"},
  {companyName: "KAVYA CONSULTING", mobileNo: "9842492892"},
  {companyName: "ANGAPPAN K", mobileNo: "9244643372"},
  {companyName: "RAHUL CREDIT SERVICES LLP", mobileNo: "7264954942"},
  {companyName: "MADURAI MEENAKSHI MARKETING", mobileNo: "9994497548"},
  {companyName: "A3 FINANCIAL SERVICES PRIVATE LIMITED", mobileNo: "8250999689"},
  {companyName: "INSIGHT BUSINESS SERVICES", mobileNo: "9142555570"},
  {companyName: "CREDIT FINCORP", mobileNo: "9847066188"},
  {companyName: "LARSEN AND TOUBRO LTD SUFIN", mobileNo: "9167973112"},
  {companyName: "PHONEPE LENDING SERVICES PRIVATE LIMITED", mobileNo: "9967581535"},
  {companyName: "DRAVYASHALA FINANCIALS SERVICES PRIVATE LIMITED", mobileNo: "9304956022"},
  {companyName: "BRIGHTWORTH ADVISORS PRIVATE LIMITED", mobileNo: "9370288258"},
  {companyName: "KRSNA FINETECH", mobileNo: "9087212674"},
  {companyName: "FRAME TECHNOLOGY MARKETING SERVICES PRIVATE LIMITED", mobileNo: "9004809895"},
  {companyName: "MOTLEY FINANCE", mobileNo: "9831108238"},
  {companyName: "NAVMAYA TECH SERVICES PRIVATE LIMITED", mobileNo: "8971515680"},
  {companyName: "FINEX MONEY MART PRIVATE LIMITED", mobileNo: "9911263300"},
  {companyName: "S K MARKETING", mobileNo: "9894586184"},
  {companyName: "ABB ENTERPRISES", mobileNo: "9330955972"},
  {companyName: "ANAFIN ADVISORS", mobileNo: "9873500415"},
  {companyName: "SOLE CAPITAL FINANCE PRIVATE LIMITED", mobileNo: "9924373709"},
  {companyName: "DHAMMA SERVICES", mobileNo: "9824440340"},
  {companyName: "AMBIT FINVEST PRIVATE LIMITED", mobileNo: "9620693338"},
  {companyName: "FINFREE ENTERPRISES", mobileNo: "9396777220"},
  {companyName: "BINARY DISTRIBUTION SERVICES PRIVATE LIMITED", mobileNo: "9811699895"},
  {companyName: "DOTPE PRIVATE LIMITED", mobileNo: "9833204108"},
  {companyName: "INSIGHT CUSTOMER CALL SOLUTIONS LIMITED", mobileNo: "9811502175"},
  {companyName: "INSTANT IT TECHNOLOGY", mobileNo: "8447788776"},
  {companyName: "CAPITAL MONEY CARE", mobileNo: "8428119828"},
  {companyName: "INDEX FINSERV", mobileNo: "6381399076"},
  {companyName: "THY 7 SERVICES", mobileNo: "8428426642"},
  {companyName: "NIRAI CORPORATE SOLUTIONS PRIVATE LIMITED", mobileNo: "9841001668"},
  {companyName: "ECULTIFY", mobileNo: "9867671904"},
  {companyName: "ECULTIFY", mobileNo: "9019541579"},
  {companyName: "ECULTIFY", mobileNo: "8169921886"},
  {companyName: "INFOSEC", mobileNo: "8698200444"}
];

/**
 * Find companies by mobile number from CSV data
 * @param {string} phoneNumber - Phone number to search for (can include country code)
 * @returns {Array} Array of matching company objects in format expected by AddDetails.js
 */
export const findCompanyByMobile = (phoneNumber) => {
  if (!phoneNumber) {
    return [];
  }
  
  // Clean the phone number - remove country code, spaces, special characters
  const cleanNumber = phoneNumber.toString().trim().replace(/\D/g, '');
  const searchNumber = cleanNumber.slice(-10); // Get last 10 digits
  
  // Find matching companies
  const matches = companyData.filter(company => {
    const companyMobile = company.mobileNo.toString().trim().replace(/\D/g, '');
    const isMatch = companyMobile === searchNumber;
    
    return isMatch;
  });
  
  // Convert to format expected by AddDetails.js (same as API format)
  const formattedMatches = matches.map(match => ({
    companyName: match.companyName,
    agreementNo: `CSV-${match.mobileNo}`, // Generate a unique agreement number for CSV entries
    mobileNo: match.mobileNo,
    source: 'CSV' // Add source identifier for debugging
  }));
  
  return formattedMatches;
};

/**
 * Merge API and CSV company data - combine both sources when available
 * @param {Object} apiResult - Result from fetchCompanyData API
 * @param {Array} csvData - Result from findCompanyByMobile
 * @returns {Array} Merged array of company objects from both sources
 */
export const mergeCompanyData = (apiResult, csvData) => {
  console.log('🔄 Merging company data - CSV:', csvData?.length || 0, 'API:', apiResult?.companies?.length || 0);
  
  let allCompanies = [];
  
  // Add CSV data if available
  if (csvData && csvData.length > 0) {
    console.log('📋 Adding CSV companies:', csvData);
    allCompanies = [...csvData];
  }
  
  // Add API data if available
  if (apiResult && apiResult.success && apiResult.companies && apiResult.companies.length > 0) {
    console.log('🌐 Adding API companies:', apiResult.companies);
    
    // Format API companies to match expected structure
    const formattedApiCompanies = apiResult.companies.map(company => ({
      companyName: company.companyName,
      agreementNo: company.agreementNo,
      mobileNo: company.mobileNo || 'N/A',
      source: 'API' // Add source identifier for debugging
    }));
    
    allCompanies = [...allCompanies, ...formattedApiCompanies];
  }
  
  // Remove duplicates based on company name (case insensitive)
  const uniqueCompanies = allCompanies.filter((company, index, self) => 
    index === self.findIndex(c => 
      c.companyName.toLowerCase() === company.companyName.toLowerCase()
    )
  );
  
  console.log('🔗 Final merged companies:', uniqueCompanies);
  console.log('🔗 Total unique companies:', uniqueCompanies.length);
  
  if (uniqueCompanies.length === 0) {
    console.log('❌ No company data found from either CSV or API');
  }
  
  return uniqueCompanies;
};

/**
 * Check if a phone number exists in CSV data
 * @param {string} phoneNumber - Phone number to check
 * @returns {boolean} True if phone number exists in CSV
 */
export const isPhoneNumberInCsv = (phoneNumber) => {
  const matches = findCompanyByMobile(phoneNumber);
  const exists = matches.length > 0;
  
  return exists;
};

/**
 * Get all company data (for debugging purposes)
 * @returns {Array} All company data from CSV
 */
export const getAllCompanyData = () => {
  return companyData;
};

/**
 * Get company count for a phone number
 * @param {string} phoneNumber - Phone number to check
 * @returns {number} Number of companies found for this phone number
 */
export const getCompanyCount = (phoneNumber) => {
  return findCompanyByMobile(phoneNumber).length;
};

// Export default object with all functions
export default {
  findCompanyByMobile,
  mergeCompanyData,
  isPhoneNumberInCsv,
  getAllCompanyData,
  getCompanyCount,
  companyData
};